import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Row,
  Col,
} from "reactstrap";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import DateRangeSelector from "./DateRangeSelector";
import {
  formatDateForPayload,
  getCurrentWeekRange,
} from "../Utils/UtilityFunctions";
import { getReservationTrends } from "../../slices/EVDashboard/ReservationTrends/thunk";

const ReservationTrends = () => {
  const currentWeekRange = getCurrentWeekRange();
  const [dateRange, setDateRange] = useState(currentWeekRange);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const reservationTrend = useSelector(
    (state) => state.ReservationTrends.reservationTrendsData
  );
  const trendData = reservationTrend?.trend || [];

  // Format dates for display (e.g., "Jan 1", "Jan 8")
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleDateString("en-US", { month: "short" });
    const day = date.getDate();
    return `${month} ${day}`;
  };

  const maxCount = Math.max(...trendData.map((item) => item.count), 0);
  // Round up to nearest multiple of 4 to avoid decimal tick values
  const yAxisMax = maxCount === 0 ? 100 : Math.ceil(maxCount / 4) * 4;

  const chartOptions = {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#FF6B35"],
    },
    markers: {
      size: 6,
      colors: ["#FF6B35"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 8,
      },
    },
    xaxis: {
      categories: trendData.map((item) =>
        formatDate(item.weekStart || item.date)
      ),
      labels: {
        style: {
          colors: "#6c757d",
          fontSize: "12px",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      title: {
        text: "Number of Reservations",
        style: {
          fontSize: "12px",
          fontWeight: 400,
          color: "#808080",
        },
      },
      min: 0,
      max: yAxisMax,
      tickAmount: 4,
      labels: {
        style: {
          colors: "#6c757d",
          fontSize: "12px",
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 0,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "14px",
      fontWeight: 400,
      offsetY: 5,
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: "#fff",
        fillColors: ["#FF6B35"],
        radius: 2,
        offsetX: -3,
        offsetY: 0,
      },
      labels: {
        colors: "#FF6B35",
        useSeriesColors: false,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 10,
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value} reservations`,
      },
    },
    colors: ["#FF6B35"],
  };

  const series = [
    {
      name: "Total Reservations",
      data: trendData.map((item) => item.count),
    },
  ];

  const handleDateRangeChange = (dateRangeData) => {
    const { startDate, endDate, type } = dateRangeData;
    const dateRange = {
      period: type,
      from: formatDateForPayload(startDate) || currentWeekRange.from,
      to: formatDateForPayload(endDate) || currentWeekRange.to,
    };
    setDateRange(dateRange);
  };

  useEffect(() => {
    if (dateRange) {
      dispatch(getReservationTrends(setLoading, dateRange));
    }
  }, [dateRange]);

  return (
    <Container fluid>
      <Row>
        <Col>
          <Card style={{ border: "1px solid #0000001A", borderRadius: "10px" }}>
            <CardBody className="p-4">
              <div className="d-flex  flex-column flex-sm-row justify-content-between align-items-start mb-3">
                <div>
                  <CardTitle
                    tag="h3"
                    className="mb-2"
                    style={{
                      fontSize: "18px",
                      color: "#0A0A0A",
                      fontWeight: "400",
                    }}
                  >
                    Reservation Trends
                  </CardTitle>
                  {/* <CardSubtitle
                    style={{
                      fontSize: "14px",
                      color: "#4A5565",
                      fontWeight: "400",
                    }}
                  >
                    Weekly reservation patterns over time
                  </CardSubtitle> */}
                </div>
                {/* <div
                  style={{
                    fontSize: "14px",
                    color: "#4A5565",
                    fontWeight: "400",
                  }}
                >
                  Trailing last 3 months
                </div> */}
                <div className="flex-shrink-0">
                  <DateRangeSelector onDateRangeChange={handleDateRangeChange} />
                </div>
              </div>
              <Chart
                options={chartOptions}
                series={series}
                type="line"
                height={300}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReservationTrends;
